// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reader-option input[data-v-720d8804]{display:none;width:100%;height:100%}.reader-option label[data-v-720d8804]{cursor:pointer}.reader-option input:checked+label[data-v-720d8804]:before{position:absolute;top:40px;left:50%;margin-left:-12px;content:\"👆\"}", ""]);
// Exports
module.exports = exports;
